module.exports = __webpack_public_path__ + "quicksilver/static/media/axis.6f014ce4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payments/banking/axis.svg
// module id = 641
// module chunks = 0